import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { trackConversion } from "@/lib/gtag";

export default function Gracias() {
  useEffect(() => {
    document.title = "¡Gracias! — Asistentes Virtual";
    trackConversion(); // Google Ads conversion (no-op until configured)
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-bgAlt px-6 text-center" data-testid="gracias-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-md"
      >
        <motion.div
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-brand-mint/15"
        >
          <Check size={40} strokeWidth={2.5} className="text-brand-mint" />
        </motion.div>
        <h1 className="mt-6 text-3xl font-medium tracking-tight text-brand-ink">¡Solicitud recibida!</h1>
        <p className="mt-3 text-[15px] leading-relaxed text-[#5F5E5A]">
          Gracias por confiar en nosotros. Revisaremos lo que nos has contado y te
          enviaremos una propuesta a tu medida en menos de 24 horas laborables.
        </p>
        <Link
          to="/"
          data-testid="gracias-back"
          className="mt-8 inline-block rounded-[10px] bg-brand-indigo px-7 py-3 text-[15px] font-medium text-white shadow-[0_8px_24px_rgba(79,70,229,0.3)] transition-transform duration-200 hover:-translate-y-0.5"
        >
          Volver al inicio
        </Link>
      </motion.div>
    </div>
  );
}
